/** Keyboard helpers shared by the list views and global shortcuts. */
export function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false
  return target.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName)
}

/**
 * True while a dialog, sheet, popover or menu is open: list shortcuts pause. Toasts are
 * non-modal dialogs too (Base UI) but must not block the keyboard: you keep triaging while the
 * "Filed… Undo" toast is visible.
 */
export const OVERLAY_SELECTOR = [
  '[role="dialog"]:not([data-slot="toast"]):not([data-closed])',
  // A dialog in its closing animation (Base UI keeps it mounted, `data-closed`) is gone for the
  // user: a key pressed right after a palette command must reach the list.
  '[role="alertdialog"]:not([data-closed])',
  '[role="menu"]:not([data-closed])',
].join(', ')

export function overlayOpen(doc: Document = document): boolean {
  return doc.querySelector(OVERLAY_SELECTOR) !== null
}

export const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.userAgent)
